/**
 * Pure H OS · Phase D · P0-1 · Decisions mock (types + live view).
 * Backed by MongoDB collection `pureh_decisions`.
 *
 * A "decision" is a cross-module governance record — R&D go/no-go,
 * finance capex approvals, launch date lock-ins, supplier switches, etc.
 * This surface is the foundational feed for Board Briefs, Owner
 * Dashboards, and the Reports page.
 */
import { liveArray } from "../services/store";

export type DecisionModule =
  | "R&D" | "Finance" | "Commerce" | "Operations"
  | "Marketing" | "Launch" | "Growth" | "AI" | "Workspace" | "Executive";

export type DecisionOutcome = "go" | "hold" | "kill" | "reformulate" | "approved" | "declined" | "deferred";

export type DecisionSeverity = "low" | "medium" | "high";

export type Decision = {
  id: string;
  title: string;
  module: DecisionModule;
  outcome: DecisionOutcome;
  severity: DecisionSeverity;
  decidedBy: string;
  requestedBy: string;
  dateRelative: string;
  budgetImpactEGP?: number;
  rationale: string;
  linkedTo?: string;      // id of linked entity (product, batch, campaign, …)
  linkedKind?: string;    // kind of that entity, e.g. "rnd_product" / "campaign"
  aiConfidence?: number;
};

export const DECISIONS: Decision[] = liveArray<Decision>("decisions");
